import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { Grid } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Fab from "@material-ui/core/Fab";

import { useEffect } from "react";
import { getImages } from "../../repositories/imageRepository";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import { useContext } from "react";
import { PointAccessContext } from "../../context/PointAccessContext";
import "./.pointAccess.css";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function ModalImages() {
  const [images, setImages] = useState([]);
  const [limit, setLimit] = useState(5);
  const [loading, setLoading] = useState(false);
  const {
    imagesSelectedsModal,
    handleSelectImage,
    openModalImages: open,
    setOpenModalImages: setOpen,
  } = useContext(PointAccessContext);
  const classes = useStyles();

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const { data } = await getImages({
          Origem: "pontoacesso",
          limit,
        });

        if (data.success) setImages(data.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getData();
  }, [limit]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {loading && open && <ModalLoading loading={loading} />}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Grid
          container
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={8}
          sm={10}
          xs={11}
          id="modal"
        >
          <Grid item xs={12} container alignItems="center" justify="center">
            <label className="title">Galeria</label>
          </Grid>

          <Grid
            item
            xs={11}
            container
            alignItems="center"
            justify="flex-start"
            spacing={1}
          >
            {images.map((img, index) => (
              <Grid
                item
                lg={3}
                md={4}
                sm={4}
                xs={6}
                key={index}
                onClick={() => handleSelectImage(img)}
              >
                <img
                  src={`data:image/jpeg;base64,${img.ImagemB64}`}
                  alt={`img-${index}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    border: imagesSelectedsModal.includes(img.Id)
                      ? "solid #8bc34a 3px"
                      : "",
                    borderRadius: 3,
                  }}
                />
              </Grid>
            ))}
          </Grid>

          {images.length === limit && (
            <Grid
              item
              xs={12}
              spacing={2}
              container
              justify="flex-end"
              style={{ marginTop: 20 }}
            >
              <Grid item xs={2} container justify="flex-end">
                <Fab
                  variant="extended"
                  className="button-more"
                  onClick={() => setLimit(limit + 5)}
                >
                  <MoreHorizIcon />
                </Fab>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Modal>
    </div>
  );
}
